import React from 'react';
import { Button, Stack } from '@mui/material';

import { calendarApi, useCalendar } from '../../api';
import { useDealActivityMutations } from '../../../api';

interface Props {
  selectedIds: string[];
  onClose: VoidFunction;
}

export const BulkActions = ({ selectedIds, onClose }: Props) => {
  const { isCompleting, isMovingToTomorrow, handleCompleteEvent, handleMoveToTomorrowEvent } = useCalendar();
  const { handleDeleteMultipleDealActivities, isDealActivityDeletingMultiple } = useDealActivityMutations();

  return (
    <Stack direction="row" gap="1rem">
      <Button
        size="small"
        variant="text"
        loading={isMovingToTomorrow}
        onClick={async () => {
          await handleMoveToTomorrowEvent(selectedIds, api => ({
            awaitRefetchQueries: true,
            refetchQueries: [api.dealActivityEventsListing],
          }));

          onClose();
        }}
      >
        Move to Tomorrow
      </Button>

      <Button
        size="small"
        variant="text"
        loading={isCompleting}
        onClick={async () => {
          await handleCompleteEvent(selectedIds, api => ({
            awaitRefetchQueries: true,
            refetchQueries: [api.dealActivityEventsListing],
          }));

          onClose();
        }}
      >
        Complete
      </Button>

      <Button
        size="small"
        variant="text"
        loading={isDealActivityDeletingMultiple}
        onClick={async () => {
          await handleDeleteMultipleDealActivities({ ids: selectedIds }, () => ({
            awaitRefetchQueries: true,
            refetchQueries: [calendarApi.dealActivityEventsListing],
          }));

          onClose();
        }}
      >
        Delete
      </Button>
    </Stack>
  );
};
